import { Field, Model } from 'serialize-ts';
import { ReferencePriceTypes } from '~shared/models/reference-price-types.enum';
import { Price, PriceItem } from '~app/modules/product/models/price.model';
import { ProductIndexOffer } from '~app/modules/product/models/product-index-offer.model';

@Model()
export class ReferencePrice {
  @Field()
  vatExcluded: Price;

  @Field()
  vatIncluded: Price;

  @Field()
  vatValue: number;

  @Field()
  discountPercentage: string;

  @Field()
  priceType: ReferencePriceTypes;

  public static mapReferencePrice(productIndexOffer: ProductIndexOffer): ReferencePrice {
    return {
      ...PriceItem.mapPriceItem(productIndexOffer?.destinationRegionInfo?.referencePrice),
      discountPercentage: productIndexOffer?.destinationRegionInfo?.referencePrice.discountPercentage,
      priceType: productIndexOffer?.destinationRegionInfo?.referencePrice.priceType
    };
  }
}
